import { createInjectable } from "ngxtension/create-injectable";
import { signal, computed, inject } from "@angular/core";
import { EncryptStorage } from "encrypt-storage";
import { environment } from "environments/environment";
import { NotificationsV2ApiService } from "./notifications-v2-api.service";
import { AuthDavesaV2Service } from "app/core/auth-davesa/auth-davesa-v2.service";

export const encryptStorage = new EncryptStorage(
  environment.ENCRYPT_STORAGE_KEY,
  {
    storageType: "sessionStorage",
  }
);

export const NotificationsV2Service = createInjectable(() => {
  const loginUser = inject(AuthDavesaV2Service).loginUser();
  const _messagesV2ApiService = inject(NotificationsV2ApiService);

  const fullNotifications = signal<any[] | null>(null);
  const notifications = signal<any[] | null>(null);
  const notification = signal<any | null>(null);
  const categories = signal<any[] | null>(null);
  const totalUnreadCount = signal<number>(0);

  const getAllNotifications = async (params: any, options?: { skipLoading?: boolean }): Promise<any> => {
    const response = await _messagesV2ApiService.getAllNotifications(params, options);
    notifications.set(response.data);
    
    if (params.read_type === 0) {
      totalUnreadCount.set(response.unfilter_count || 0);
    }
    
    return response.data;
  };

  const getFullNotifications = async (params: any): Promise<any> => {
    const response = await _messagesV2ApiService.getFullNotifications(params);
    notifications.set(response);
    return response;
  };

  const updateNotificationItem = async (data: any): Promise<any> => {
    const response = await _messagesV2ApiService.updateNotificationInfo(data);
    notification.set(response);
    return response;
  };

  const markAllAsReadNotification = async (): Promise<any> => {
    const response = await _messagesV2ApiService.markAllAsReadNotification();
    totalUnreadCount.set(0);
    return response;
  };

  const decrementUnreadCount = (): void => {
    const currentCount = totalUnreadCount();
    if (currentCount > 0) {
      totalUnreadCount.set(currentCount - 1);
    }
  };

  const incrementUnreadCount = (): void => {
    totalUnreadCount.set(totalUnreadCount() + 1);
  };

  const notificationCategories = async (params: any): Promise<any> => {
    const response = await _messagesV2ApiService.notificationCategories(params);
    categories.set(response);
    return response;
  };

  return {
    fullNotifications: computed(() => fullNotifications()),
    notifications: computed(() => notifications()),
    notification: computed(() => notification()),
    categories: computed(() => categories()),
    totalUnreadCount: computed(() => totalUnreadCount()),

    getAllNotifications,
    updateNotificationItem,
    markAllAsReadNotification,
    notificationCategories,
    getFullNotifications,
    decrementUnreadCount,
    incrementUnreadCount
  };
});
